module.exports = __webpack_public_path__ + "img/terms-icons.9a8a40a5.png";